(function () {
  'use strict';

  function onDomReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  function isAIChatbotsPage() {
    return window.location && window.location.pathname === '/ai-chatbots';
  }

  function getCategoryFromUrl() {
    try {
      var u = new URL(window.location.href);
      var cat = u.searchParams.get('category');
      return cat && cat.trim() ? cat.trim() : '';
    } catch (_) {
      return '';
    }
  }

  function updateHeaderForCategory() {
    if (!isAIChatbotsPage()) return;
    var cat = getCategoryFromUrl();
    if (!cat) return;
    var h1 = document.querySelector('h1');
    if (h1 && !/AI Chatbots/i.test(h1.textContent)) return;
    if (h1) h1.textContent = cat + ' AI Chatbots';
    // Also update document.title if present
    try {
      if (document && document.title) {
        document.title = cat + ' - AI Chatbots + Art Generator';
      }
    } catch { /* Error ignored */ }
  }

  function ensureSearchBar() {
    if (!isAIChatbotsPage()) return null;
    var container = document.querySelector('.demo-content');
    if (!container) return null;

    var existing = document.getElementById('ai-chatbots-search');
    if (existing) return existing;

    var wrapper = document.createElement('div');
    wrapper.id = 'ai-chatbots-search';
    wrapper.className = 'mdl-textfield mdl-js-textfield';
    wrapper.style.margin = '8px 0 16px 0';

    wrapper.innerHTML = [
      '<div id="remote" class="typeahead-container" style="position: relative; max-width: 560px;">',
      '  <input class="typeahead mdl-textfield__input" type="text"',
      '         id="ai-chatbots-search-input"',
      '         placeholder="Search categories (e.g., Fantasy)">',
      '</div>',
    ].join('');

    // Insert near the top, before related categories or lists
    var insertionPoint = container.firstElementChild || container;
    container.insertBefore(wrapper, insertionPoint.nextSibling);

    return wrapper;
  }

  function replaceContentFromResponse(htmlText) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlText, 'text/html');
      var newContent = doc.querySelector('.demo-content');
      var current = document.querySelector('.demo-content');
      if (newContent && current) {
        current.innerHTML = newContent.innerHTML;
        // Rebind chip click handlers after replacing DOM
        bindChipClicks();
        updateHeaderForCategory();
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.error('Failed to replace ai-chatbots content', e);
      window.location.reload();
    }
  }

  function navigateToCategory(category) {
    if (!category) return;
    var url = '/ai-chatbots?category=' + encodeURIComponent(category);
    if (window.history && window.history.pushState) {
      window.history.pushState({ category: category }, '', url);
      fetch(url, {
        headers: { 'X-Requested-With': 'fetch', Accept: 'text/html' },
      })
        .then(function (r) {
          return r.text();
        })
        .then(replaceContentFromResponse)
        .catch(function () {
          window.location.href = url;
        });
    } else {
      window.location.href = url;
    }
  }

  function bindChipClicks() {
    // Intercept related/category chip clicks for SPA update
    var container = document.querySelector('.demo-content');
    if (!container) return;
    container
      .querySelectorAll('a[href^="/ai-chatbots?category="]')
      .forEach(function (anchor) {
        anchor.addEventListener('click', function (ev) {
          ev.preventDefault();
          try {
            var u = new URL(anchor.href, window.location.origin);
            var cat =
              u.searchParams.get('category') || anchor.textContent.trim();
            navigateToCategory(cat);
          } catch (_) {
            window.location.href = anchor.href;
          }
        });
      });
  }

  function initTypeahead($input) {
    try {
      // Prefer existing global Bloodhound instance from autocomplete.js
      var engine = window.bloodhoundInstance ? window.bloodhoundInstance : null;
      if (!engine && window.Bloodhound) {
        engine = new window.Bloodhound({
          datumTokenizer: window.Bloodhound.tokenizers.obj.whitespace('value'),
          queryTokenizer: window.Bloodhound.tokenizers.whitespace,
          remote: {
            url: '/autocomplete/dataset?query=%QUERY',
            wildcard: '%QUERY',
            transform: function (response) {
              return (response && response.results ? response.results : []).map(
                function (r) {
                  if (typeof r === 'string') return { value: r, typed: '' };
                  return {
                    value: r.suggestion || r.value || '',
                    typed: response.typed || '',
                  };
                }
              );
            },
          },
          local: [],
        });
      }
      if (!engine || typeof $input.typeahead !== 'function') return;

      var templates = {
        suggestion: function (data) {
          var displayType = data.type === 'data' ? '' : data.type || '';
          return (
            '<div><span class="typed-already">' +
            (data.typed || '') +
            '</span><span class="typing-suggestion">' +
            (data.suggestion || '') +
            '</span> <span class="typing-type">' +
            displayType +
            '</span></div>'
          );
        },
      };

      $input.typeahead(null, {
        name: 'ai-chatbots-categories',
        display: function (d) {
          return d && (d.value || d);
        },
        source: engine,
        minLength: 0,
        limit: 10,
        templates: templates,
      });

      $input.on('typeahead:select', function (_, selected) {
        var val = selected && (selected.value || selected);
        navigateToCategory(val);
      });

      $input.on('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var val = e.target.value;
          navigateToCategory(val);
        }
      });
    } catch (e) {
      console.warn('Typeahead init failed', e);
    }
  }

  function enhance() {
    if (!isAIChatbotsPage()) return;
    updateHeaderForCategory();
    var wrapper = ensureSearchBar();
    if (!wrapper) return;

    bindChipClicks();

    // Wait for vendors and autocomplete to be ready
    var start = function () {
      var input = document.getElementById('ai-chatbots-search-input');
      if (!input) return;
      if (window.jQuery) {
        initTypeahead(window.jQuery(input));
      }
    };

    if (window.ensureVendorsReady) {
      window.ensureVendorsReady().then(start).catch(start);
    } else {
      start();
    }

    // Register popstate handler with coordinator if available
    var aiChatbotsPopstateHandler = function () {
      if (isAIChatbotsPage()) {
        // Reload current category view
        fetch(window.location.href, {
          headers: { 'X-Requested-With': 'fetch', Accept: 'text/html' },
        })
          .then(function (r) {
            return r.text();
          })
          .then(replaceContentFromResponse)
          .catch(function () {
            window.location.reload();
          });
      }
    };

    if (window.PopStateCoordinator) {
      window.PopStateCoordinator.register(
        aiChatbotsPopstateHandler,
        10, // Low priority - only for AI chatbots page
        'AIChatbotsEnhancements'
      );
    } else {
      window.addEventListener('popstate', aiChatbotsPopstateHandler);
    }
  }

  onDomReady(enhance);
})();
